import {
  GET_PERFORMANCESCOREDETAIL,
  GET_PERFORMANCESCOREDETAIL_SUCCESS,
  GET_PERFORMANCESCOREDETAIL_FAIL,
  DELETE_PERFORMANCESCOREDETAIL,
  DELETE_PERFORMANCESCOREDETAIL_SUCCESS,
  DELETE_PERFORMANCESCOREDETAIL_FAIL,
  UPDATE_PERFORMANCESCOREDETAIL,
  UPDATE_PERFORMANCESCOREDETAIL_SUCCESS,
  UPDATE_PERFORMANCESCOREDETAIL_FAIL,
  ADD_NEW_PERFORMANCESCOREDETAIL,
  ADD_PERFORMANCESCOREDETAIL_SUCCESS,
  ADD_PERFORMANCESCOREDETAIL_FAIL,
  PERFORMANCESCOREDETAIL_LOADING,
  PERFORMANCESCOREDETAIL_RESET,
} from "./actionType";

export const resetPerformanceScoreDetailState = (actionType) => ({
  type: PERFORMANCESCOREDETAIL_RESET,
  payload: { actionType },
});

export const getPerformanceScoreDetailSuccess = (actionType, data) => ({
  type: GET_PERFORMANCESCOREDETAIL_SUCCESS,
  payload: { actionType, data },
});

export const getPerformanceScoreDetailFail = (actionType, error) => ({
  type: GET_PERFORMANCESCOREDETAIL_FAIL,
  payload: { actionType, error },
});

export const getPerformanceScoreDetail = data => ({
  type: GET_PERFORMANCESCOREDETAIL,
  payload: data,
});

export const getPerformanceScoreDetailLoading = () => ({
  type: PERFORMANCESCOREDETAIL_LOADING
});

export const deletePerformanceScoreDetail = data => ({
  type: DELETE_PERFORMANCESCOREDETAIL,
  payload: data,
});

export const deletePerformanceScoreDetailSuccess = data => ({
  type: DELETE_PERFORMANCESCOREDETAIL_SUCCESS,
  payload: data,
});

export const deletePerformanceScoreDetailFail = error => ({
  type: DELETE_PERFORMANCESCOREDETAIL_FAIL,
  payload: error,
});

export const updatePerformanceScoreDetail = data => ({
  type: UPDATE_PERFORMANCESCOREDETAIL,
  payload: data,
});

export const updatePerformanceScoreDetailFail = error => ({
  type: UPDATE_PERFORMANCESCOREDETAIL_FAIL,
  payload: error,
});

export const updatePerformanceScoreDetailSuccess = data => ({
  type: UPDATE_PERFORMANCESCOREDETAIL_SUCCESS,
  payload: data,
});

export const addNewPerformanceScoreDetail = data => ({
  type: ADD_NEW_PERFORMANCESCOREDETAIL,
  payload: data,
});

export const addPerformanceScoreDetailSuccess = data => ({
  type: ADD_PERFORMANCESCOREDETAIL_SUCCESS,
  payload: data,
});

export const addPerformanceScoreDetailFail = error => ({
  type: ADD_PERFORMANCESCOREDETAIL_FAIL,
  payload: error,
});